<template>
 <v-container fluid class='fill-height pa-0 ma-0' id='container'>
  <v-navigation-drawer style='height:100%;'
     absolute
     permanent
     :mini-variant.sync='miniLeft'
   >
     <template v-slot:prepend>
       <v-list-item two-line>
         <v-list-item-avatar>
           <v-icon>mdi-tune</v-icon>
         </v-list-item-avatar>

         <v-list-item-content>
           <v-list-item-title>Properties</v-list-item-title>
           <v-list-item-subtitle>Change them</v-list-item-subtitle>
         </v-list-item-content>

         <v-btn
           icon
           @click.stop='miniLeft = !miniLeft'
         >
           <v-icon>mdi-chevron-left</v-icon>
         </v-btn>
       </v-list-item>
       <v-container v-if='!miniLeft'  style="max-height: 85vh" class="overflow-y-auto">
       <v-container>
        <v-select
          :items="vertexEncodingItems"
          label="Vertex Size Encoding"
          v-model='vertexEncoding'
          v-on:change="switchEncoding()"
        ></v-select>
    </v-container>
    <v-container>
    <v-subheader class='pl-0 subtitle-1'>Show Labels</v-subheader>
    <v-switch
      color='primary'
      v-model='showLabels'
      :label='` ${showLabels.toString()}`'
    ></v-switch>
    </v-container>
    <v-container class='mb-8'>
      <v-radio-group v-model="selectedMode">
      <v-subheader class='pl-0 subtitle-1'>Exploration Modes</v-subheader>
      <v-radio
        color='primary'
        value='hover'
        v-on:change="modeSwitch('hover')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Hover</span>
            </template>
            <span>Hover line or node to emphasize it</span>
          </v-tooltip>
        </template></v-radio>
      <v-radio
        color='primary'
        value='intersection'
        v-on:change="modeSwitch('intersection')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Intersection</span>
            </template>
            <span>Click lines to show set intersections</span>
          </v-tooltip>
        </template></v-radio >
      <v-radio
        color='primary'
        value='union'
        v-on:change="modeSwitch('union')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Union</span>
            </template>
            <span>Click lines to show set union</span>
          </v-tooltip>
        </template></v-radio >
      <v-radio
        color='primary'
        value='complement'
        v-on:change="modeSwitch('complement')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Complement</span>
            </template>
            <span>Click lines to show set complement</span>
          </v-tooltip>
        </template></v-radio >
      <v-radio
        color='primary'
        value='relativeComplement'
        v-on:change="modeSwitch('relativeComplement')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Symmetric Difference</span>
            </template>
            <span>Click lines to show the symmetric difference of selected sets</span>
          </v-tooltip>
        </template></v-radio >
      <v-radio
        color='primary'
        value='subtract'
        v-on:change="modeSwitch('subtract')"
      >
        <template v-slot:label>
          <v-tooltip right open-delay='500'>
            <template v-slot:activator="{ on }">
              <span v-on="on">Subtract</span>
            </template>
            <span>Click line to create union<br> Click + CTRL line to subtract from union</span>
          </v-tooltip>
        </template>
      </v-radio >
    </v-radio-group>

      <v-btn bottom block tile outlined color="primary" v-on:click="refreshSelection">
        <v-icon left>mdi-refresh</v-icon> Reset Selection
      </v-btn>
    </v-container>

  <v-container>
    <v-btn bottom block tile outlined color="primary" v-on:click="exportAsPng">
      <v-icon left>mdi-content-save</v-icon> Export PNG
    </v-btn>
  </v-container>
  <v-container>
    <v-btn bottom block tile outlined color="primary" v-on:click="exportAsSvg">
      <v-icon left>mdi-content-save</v-icon> Export SVG
    </v-btn>
  </v-container>
  <v-container class="mt-8">
    <v-btn bottom block tile outlined color="primary" :to="{ name: 'dataDetail', params: { dataId: map.data }}">
      <v-icon left>mdi-pencil-outline</v-icon> Create New
    </v-btn>
  </v-container>
  </v-container>
     </template>

     <v-divider></v-divider>

   </v-navigation-drawer>
  <svg id='drawArea' ref='drawAreaRef' style='height:100%;  width:100%'></svg>
  <div class='tooltip'/>
  <v-navigation-drawer style='height:100%;'
      absolute
      permanent
      right
      :mini-variant.sync='miniRight'
    >
      <template v-slot:prepend>
        <v-list-item two-line>
        <v-list-item-avatar>
          <v-icon>mdi-information</v-icon>
        </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Statistics</v-list-item-title>
            <v-list-item-subtitle>More Data</v-list-item-subtitle>
          </v-list-item-content>

          <v-btn
            icon
            @click.stop='miniRight = !miniRight'
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-item>
        <v-expand-transition>
        <v-container v-show='!miniRight' style="max-height: 85vh" class="overflow-y-auto pb-0">
            <v-card flat>
              <v-card-title>{{map.data_name}}</v-card-title>
              <v-card-text>{{map.data_description}}</v-card-text>
            </v-card>
            <v-card flat >
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on"># Selected Nodes</span>
                  </template>
                  <span>The number of currently selected nodes</span>
                </v-tooltip>
                </v-card-title><!---->
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{selectedNodes}}</v-card-text>
            </v-card>
            <v-card flat v-for='value in map.output.stats' v-bind:key='value[0]'>
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{value[0]}}</span>
                  </template>
                  <span>{{tooltip[value[0]]}}</span>
                </v-tooltip>
                </v-card-title>
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{value[1]}}</v-card-text>
            </v-card>
            <v-card flat >
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">Support Algorithm</span>
                  </template>
                  <span>The support algorithm used to create the map</span>
                </v-tooltip>
                </v-card-title><!---->
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{map.support_algorithm_readable}}</v-card-text>
            </v-card>
            <v-card flat >
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">Insertion Algorithm</span>
                  </template>
                  <span>The insertion algorithm to insert the set aside vertices</span>
                </v-tooltip>
                </v-card-title><!---->
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{map.insertion_algorithm_readable}}</v-card-text>
            </v-card>
            <v-card flat >
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">Initial Layout</span>
                  </template>
                  <span>The initial layout algorithm used to embed the graph</span>
                </v-tooltip>
                </v-card-title><!---->
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{map.initial_layout_algorithm_readable}}</v-card-text>
            </v-card>
            <v-card flat >
              <v-card-title class="subtitle-1 pb-0 mb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">Schematization</span>
                  </template>
                  <span>The schematization algorithm used to schematize the initial layout</span>
                </v-tooltip>
                </v-card-title><!---->
              <v-card-text class='text-right subtitle-2 pt-0 pt-0'>{{map.schematization_algorithm_readable}}</v-card-text>
            </v-card>
        </v-container>
        </v-expand-transition>
      </template>

      <v-divider></v-divider>

    </v-navigation-drawer>
    <!--<v-container class="legend">
      <v-btn text block @click="showLegend = !showLegend">
        Key to Lines
        <v-icon v-if="showLegend">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-up</v-icon>
      </v-btn>
      <v-container v-show="showLegend" class="pt-0">
      <v-container class="px-0">
      <v-row>
      <template v-for="(value, key) in legendColor">
        <v-col :key="key"  class="col-6 py-1" v-bind:style="{fontWeight: value.IsHover}" v-on:mouseover="handleMouseOverLine(key)" v-on:mouseleave="handleMouseOutLine(key)" v-on:click="handleMouseClickLine(key)">
          <span class="key-dot" v-bind:style="{backgroundColor: value.Color}"></span>
          {{key}}
        </v-col>
      </template>
      </v-row>
      </v-container>
      </v-container>
    </v-container>-->
  </v-container>
</template>

<script>

import * as d3 from 'd3'
import * as d3Scale from 'd3-scale'
import * as d3Shape from 'd3-shape'
import { saveAs } from 'file-saver'
import 'canvas-to-blob'
import * as saveSvgAsPng from 'save-svg-as-png'
// import 'd3-svg-to-png'

export default {
  name: 'MetroMap',
  props: {
    map: Object
  },
  watch: {
    map: function (newVal, oldVal) { // watch it
      this.renderMap(this.map.output)
    },
    fontSize: function (newVal, oldVal) {
      // d3.selectAll('.text').style('font-size', this.fontSize + 'px')
    },
    showLabels: function (newVal, oldVal) {
      // console.log('hello')
      d3.selectAll('.text').style('opacity', this.showLabels ? 1 : 0)
    }
  },
  data () {
    return {
      metroMap: null,
      miniLeft: true,
      miniRight: true,
      showLegend: true,
      legendColor: null,
      showDummy: false,
      clickedLines: new Set(),
      clickedLinesSubtract: new Set(),
      dontHover: false,
      fontSize: 6,
      lineStroke: 8,
      animationTime: 3000,
      showLabels: true,
      xScale: null,
      yScale: null,
      div: null,
      vertexEncoding: 'Max # sets',
      vertexEncodingItems: ['Linear', 'Max # sets'],
      lineSet: {},
      nodeLineSet: {},
      nodeAnimation: {},
      tooltip: {},
      selectedNodes: 0,
      selectedMode: 'hover',
      selectedLine: '',
      numNodes: 0
    }
  },
  beforeMount () {
    this.populateTooltips()
  },
  mounted () {
    this.renderMap(this.map.output)
    this.populateTooltips()
    // this.timer = setTimeout(this.loadMap, 3000)
  },

  initParams () {
    this.fontSize = 6
    this.strokeWidth = this.map.options.stroke
  },

  paramChanged () {
    this.renderMap(this.map.output)
  },

  methods: {
    renderMap (map) {
      var options = map.options
      const margin = { top: 50, bottom: 50, left: 50, right: 50 }

      this.fontSize = options.fontSize

      // Add a set for each line with node IDs for O(1) lookup
      this.numNodes = 0
      map.nodes.forEach((value) => {
        this.nodeLineSet[value.Id] = new Set()
        this.nodeAnimation[value.Id] = this.animationTime

        if (!value.IsDummy) {
          this.numNodes++
        }
      })

      map.paths.forEach((value) => {
        var set = new Set()
        value.Points.forEach(p => {
          if (p.Id >= 0) {
            set.add(p.Id)
            this.nodeLineSet[p.Id].add(value.Label)
          }
        })
        this.lineSet[value.Label] = set
      })

      // Create the color scale
      var colorScale = d3Scale.scaleOrdinal(['#4E79A7', '#E15759', '#59A14F',
        '#D37295', '#9D7660', '#F28E2B', '#499894',
        '#79706E', '#B07AA1',
        '#B6992D', '#A0CBE8', '#FFBE7D',
        '#8CD17D', '#F1CE63',
        '#86BCB6', '#FF9D9A', '#BAB0AC',
        '#FABFD2', '#D4A6C8', '#D7B5A6'])

      /* colorScale = d3Scale.scaleOrdinal(['#8dd3c7', '#fb8072',
        '#80b1d3', '#b3de69', '#bebada', '#ffed6f',
        '#9467BD', '#d9d9d9', '#bc80bd',
        '#ffffb3', '#ccebc5', '#fccde5'])

      var colorScale = d3Scale.scaleOrdinal(['#1F77B4', '#FF7F0E',
        '#2CA02C', '#D62728', '#17BECF', '#FF9896',
        '#9467BD', '#8C564B', '#E377C2',
        '#F700C2', '#7F7F7F', '#BCBD22',
        '#9EDAE5', '#AEC7E8',
        '#FFBB78', '#98DF8A', '#C5B0D5',
        '#C49C94', '#C7C7C7', '#DBDB8D'])
      */

      // Calculate initale scale for centering and displaying the whole map
      // var dW = (this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) / (options.drawArea)
      // var dH = (this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) / (options.drawArea)
      // var scale = 1
      // var translateX = 0
      // var translateY = 0

      // console.log('wC',clientHeight this.$refs.drawAreaRef.
      // width = this.$refs.drawAreaRef.clientWidth)
      // console.log('wH', this.$refs.drawAreaRef.clientHeight)
      // console.log('w', dW)
      // console.log('h', dH)
      // if (dW > dH) {
      //  scale = Math.sqrt(dH)
      //  translateX = ((this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) - options.drawArea * scale) / 2
      //  translateY = margin.top * 1 / scale
      // } else {
      //  scale = dW
      //  translateY = ((this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) - options.drawArea * scale) / 2
      //  translateX = margin.left * 1 / scale
      // }
      // console.log('s', scale)
      // console.log('tX', translateX)
      // console.log('tY', translateY)
      // initialize the svg element and add zoom capability, apply initial scale and translation to zoom

      // Calculate initale scale for centering and displaying the whole map
      if (options['width'] === undefined || options['height'] === undefined) {
        options['width'] = options.drawArea
        options['height'] = options.drawArea
      }

      var dW = (this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) / (options.width)
      var dH = (this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) / (options.height)
      var scale = 1
      var translateX = 0
      var translateY = 0

      if (dW > dH) {
        scale = dH
        translateX = ((this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) - options.width * scale) / 2
        translateY = margin.top
      } else {
        scale = dW
        translateY = ((this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) - options.height * scale) / 2
        translateX = margin.left
      }

      var svg = d3.select('#drawArea')
        .call(d3.zoom().on('zoom', function () {
          svg.attr('transform', d3.event.transform)
        }))
        .call(d3.zoom().transform, d3.zoomIdentity.translate(translateX, translateY).scale(scale))
        .append('g')
        .attr('transform', 'translate(' + translateX + ',' + translateY + ') scale(' + scale + ',' + scale + ')')
      // calculate the x,y linear scale
      var xScale = d3Scale.scaleLinear().domain([0, options.width]).range([0, options.width])
      var yScale = d3Scale.scaleLinear().domain([0, options.height]).range([0, options.height])

      this.xScale = xScale
      this.yScale = yScale

      // create two groups for lines and nodes, this is necessary for drawing nodes on top of lines
      var chartLayer2 = svg
        .append('g')

      var chartLayer1 = svg
        .append('g')

      // create the legend
      var n = Math.ceil(map.paths.length / 2) - 1
      var strokeW = 6
      var distance = 30
      var distX = this.$refs.drawAreaRef.clientWidth * 0.3 / 2
      var marginL = { left: 20, right: 20, top: 60, bottom: 40 }

      var legendX = this.$refs.drawAreaRef.clientWidth * 0.65
      var legendY = this.$refs.drawAreaRef.clientHeight - n * distance - marginL.bottom - marginL.top

      var legend = d3.select('#drawArea').append('g')

      legend.style('opacity', 0.8)

      legend.append('rect')
        .attr('x', legendX)
        .attr('y', legendY)
        .attr('width', this.$refs.drawAreaRef.clientWidth * 0.3)
        .attr('height', n * distance + marginL.bottom + marginL.top)
        .style('fill', 'white')

      legend.selectAll('line')
        .data(map.paths)
        .enter()
        .append('line')
        .attr('class', 'lineLegend')
        .attr('x1', function (g, i) {
          return legendX + marginL.left + i % 2 * distX
        })
        .attr('x2', function (g, i) {
          return legendX + marginL.left + i % 2 * distX + 35
        })
        .attr('y1', function (g, i) {
          return legendY + Math.floor(i / 2) * distance + marginL.top
        })
        .attr('y2', function (g, i) {
          return legendY + Math.floor(i / 2) * distance + marginL.top
        })
        .style('stroke-width', strokeW)
        .style('stroke', d => d['Color'])
        // .style('stroke', d => colorScale(d['Label']))

      legend.selectAll('text')
        .data(map.paths)
        .enter()
        .append('text')
        .attr('class', 'legend')
        .attr('x', function (g, i) {
          return legendX + marginL.left + i % 2 * distX + 35 + 10
        })
        .attr('y', function (g, i) {
          return legendY + Math.floor(i / 2) * distance + marginL.top + 6
        })
        .html(g => g.Label)
        .style('font-size', '18px')
        .style('font-family', 'Roboto')
        .style('fill', 'black')
        .style('cursor', 'pointer')
        .style('font-weight', 'normal')

      legend.append('text')
        .attr('id', 'legendHeader')
        .attr('x', this.$refs.drawAreaRef.clientWidth * 0.8)
        .attr('y', legendY + 10 + 18)
        .html('Key to Lines &#709;')
        .style('shape-rendering', 'crisp-edges')
        .style('stroke', 'none')
        .style('font-size', '20px')
        .style('font-family', 'Roboto Mono')
        .style('font-weight', 'normal')
        .style('fill', 'black')
        .style('text-anchor', 'middle')
        .style('cursor', 'pointer')
        .on('click', function (d, i) {
          if (!this.showLegend) {
            legend.transition()
              .duration(500)
              .attr('transform', 'translate(0,' + (n * distance + 7 + marginL.bottom) + ')')
            legend.select('#legendHeader').html('Key to Lines &#708;')
          } else {
            legend.transition()
              .duration(500)
              .attr('transform', 'translate(0,0)')
            legend.select('#legendHeader').html('Key to Lines &#709;')
          }
          this.showLegend = !this.showLegend
        })

      legend.append('line')
        .attr('x1', this.$refs.drawAreaRef.clientWidth * 0.65 + 10)
        .attr('x2', this.$refs.drawAreaRef.clientWidth * 0.95 - 10)
        .attr('y1', legendY + 10 + 18 + 10)
        .attr('y2', legendY + 10 + 18 + 10)
        .html('Key to Lines')
        .style('stroke', 'black')
        .style('stroke-width', 2)

      // create circle nodes
      var nodeGroup = chartLayer1
        .selectAll('circle')
        .data(map.nodes.filter(function (d) { return d['IsDummy'] === false }))
        .enter()

      // create tick nodes
      nodeGroup
        .append('circle')
        .attr('class', 'node')
        .attr('cx', g => xScale(g['X']))
        .attr('cy', g => yScale(g['Y']))
        // .attr('r', g => this.lineStroke / 2 * this.scaleStationLinear(g['Id']))
        .attr('r', g => this.lineStroke / 2 * g['PortDegree'] * 1.1)
        .style('fill', 'white')
        .style('stroke', 'black')
        .style('stroke-width', 2)

      /* var nodeGroup2 = chartLayer1
        .selectAll('rect')
        .data(map.nodes.filter(function (d) { return d['Degree'] <= 2 && d['IsDummy'] === false }))
        .enter()

      /*
      nodeGroup2
        .append('rect')
        .attr('class', 'node')
        .attr('x', g => xScale(g['X']))
        .attr('y', g => yScale(g['Y']))
        .attr('width', this.lineStroke / 2)
        .attr('height', this.lineStroke * 1.2)
        .attr('transform', g => 'rotate(' + g['Angle'] * (180 / Math.PI) + ' ' + xScale(g['X']) + ' ' + yScale(g['Y']) + ')')
        .style('fill', g => {
          // console.log(this.nodeLineSet[g.Id].values().next().value)
          return colorScale(this.nodeLineSet[g.Id].values().next().value)
        })

      nodeGroup2
        .append('circle')
        .attr('class', 'node')
        .attr('cx', g => xScale(g['X']))
        .attr('cy', g => yScale(g['Y']))
        .attr('r', g => this.lineStroke * this.scaleStation(g['Id']))
        .style('fill', 'white')
        .style('stroke', 'black')
        .style('stroke-width', 2) */

      var textGroup = chartLayer1
        .selectAll('text')
        .data(map.labels)
        .enter()

      textGroup
        .append('text')
        .attr('class', 'text')
        .attr('x', g => (xScale(g['X'])))
        .attr('y', g => yScale(g['Y']))
        .html(g => {
          if (g['Abbr']) {
            return g['Text'].substring(0, 14) + '..'
          } else {
            return g['Text']
          }
        })
        .style('shape-rendering', 'crisp-edges')
        .style('stroke', 'none')
        .style('font-size', this.fontSize + 'px')
        .style('font-family', 'PT Sans Narrow')
        // .style('font-family', 'Roboto Mono, monospace')
        .style('text-anchor', g => {
          switch (g['Align']) {
            case 'C':
              return 'middle'
            case 'R':
              return 'end'
            case 'L':
              return 'start'
            default:
              return 'middle'
          }
        })
        .attr('transform', g => 'rotate(' + g['Angle'] + ' ' + xScale(g['X']) + ' ' + yScale(g['Y']) + ')')
        .style('pointer-events', g => {
          if (g['Text'].length > 16) {
            return 'auto'
          } else {
            return 'none'
          }
        })

      /* var bb1 = chartLayer2
        .selectAll('.bb1')
        .data(map.labels)
        .enter()

      bb1
        .append('line')
        .attr('class', 'bb1')
        .attr('x1', g => (xScale(g['X1'])))
        .attr('y1', g => yScale(g['Y1']))
        .attr('x2', g => (xScale(g['X2'])))
        .attr('y2', g => yScale(g['Y2']))
        .style('stroke', 'red')
        .style('stroke-width', 1)

      var bb2 = chartLayer2
        .selectAll('.bb2')
        .data(map.labels)
        .enter()

      bb2
        .append('line')
        .attr('class', 'bb2')
        .attr('x1', g => (xScale(g['X2'])))
        .attr('y1', g => yScale(g['Y2']))
        .attr('x2', g => (xScale(g['X3'])))
        .attr('y2', g => yScale(g['Y3']))
        .style('stroke', 'red')
        .style('stroke-width', 1)

      var bb3 = chartLayer2
        .selectAll('.bb3')
        .data(map.labels)
        .enter()

      bb3
        .append('line')
        .attr('class', 'bb2')
        .attr('x1', g => (xScale(g['X3'])))
        .attr('y1', g => yScale(g['Y3']))
        .attr('x2', g => (xScale(g['X4'])))
        .attr('y2', g => yScale(g['Y4']))
        .style('stroke', 'red')
        .style('stroke-width', 1)

      var bb4 = chartLayer2
        .selectAll('.bb4')
        .data(map.labels)
        .enter()

      bb4
        .append('line')
        .attr('class', 'bb2')
        .attr('x1', g => (xScale(g['X4'])))
        .attr('y1', g => yScale(g['Y4']))
        .attr('x2', g => (xScale(g['X1'])))
        .attr('y2', g => yScale(g['Y1']))
        .style('stroke', 'red')
        .style('stroke-width', 1) */

      var line = d3Shape.line().curve(d3.curveCardinal.tension(0.90)).x(d => {
        return xScale(d['X'] + this.lineStroke * d['VX'] * 1.2)
      }).y(d => yScale(d['Y'] + this.lineStroke * d['VY'] * 1.2))

      var lineGroup = chartLayer2
        .selectAll('.line')
        .data(map.paths)
        .enter()

      lineGroup
        .append('path')
        .attr('id', d => d['Label'])
        .attr('class', 'line')
        .attr('d', g => line(g['Points']))
        .style('z-index', -3)
        .style('fill', 'none')
        .style('stroke', d => d['Color'])
        // .style('stroke', d => colorScale(d['Label']))
        .style('stroke-width', this.lineStroke)

      // give colors to the legend
      this.legendColor = {}
      map.paths.forEach((path) => {
      // d3.select('#label' + path.Label).style('background-color', 'green')
        this.legendColor[path.Label] = {}
        this.legendColor[path.Label].Color = colorScale(path.Label)
        this.legendColor[path.Label].IsHover = 'normal'
      })

      this.selectedNodes = this.numNodes
      // uncomment and comment next line if in debug without animationTime
      // this.addHoverFunc()
      this.animatePath(map)
    },
    handleMouseOverNode (d, i) { // Add interactivity
      // Use D3 to select element, change color and size
      if (d.Data.length <= 0) {
        return
      }

      var html = '' + d.Label + '<br><br>'
      for (const [key, value] of Object.entries(d.Data)) {
        html += '<p style="float: left;">' + key.substring(1, key.length - 1) + ': </p><p style="float: right;">' + value + '</p>'
        html += '<div style="clear: both;"></div>'
      }

      d3.select('.tooltip').transition()
        .duration(200)
        .style('opacity', 0.9)
      d3.select('.tooltip').html(html)
        .style('left', (d3.event.pageX) + 'px')
        .style('top', (d3.event.pageY - 28) + 'px')

      if (this.selectedMode !== 'hover') {
        return
      }

      var tthis = this
      d3.selectAll('.line')
        .filter(function (dd) {
          return !tthis.nodeLineSet[d.Id].has(dd.Label)
        })
        .transition()
        .duration(200)
        .style('opacity', 0.1)

      var union = new Set()
      this.nodeLineSet[d.Id].forEach(value => {
        this.lineSet[value].forEach(id => {
          union.add(id)
        })
      })

      var selection = d3.selectAll('.node')
        .filter(function (dd) {
          return !union.has(dd.Id)
        })
        .transition()
        .duration(200)
        .style('opacity', 0.1)

      d3.selectAll('.text')
        .filter(function (dd) {
          return !union.has(dd.Id)
        })
        .transition()
        .duration(200)
        .style('opacity', this.showLabels ? 0.1 : 0.0)

      d3.selectAll('.legend')
        .filter(function (dd) {
          return tthis.nodeLineSet[d.Id].has(dd.Label)
        })
        .style('font-weight', 'bold')

      this.selectedNodes = this.numNodes - selection.size()

      // this.nodeLineSet[d.Id].forEach(value => {
      //  this.legendColor[value].IsHover = 'bold'
      // })
      // var temp = this.legendColor
      // this.legendColor = []
      // this.legendColor = temp
    },

    handleMouseOutNode (d, i) {
      // Use D3 to select element, change color back to normal
      d3.select('.tooltip').transition()
        .duration(500)
        .style('opacity', 0)

      if (this.selectedMode !== 'hover') {
        return
      }

      d3.selectAll('.line')
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      d3.selectAll('.node')
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      d3.selectAll('.text')
        .transition()
        .duration(200)
        .style('opacity', this.showLabels ? 1.0 : 0.0)

      d3.selectAll('.legend')
        .style('font-weight', 'normal')

      this.selectedNodes = this.numNodes

      // this.nodeLineSet[d.Id].forEach(value => {
      //  this.legendColor[value].IsHover = 'normal'
      // })

      // var temp = this.legendColor
      // this.legendColor = []
      // this.legendColor = temp
    },

    handleMouseClickLineD3 (d, i) {
      this.handleMouseClickLine(d.Label)
    },

    handleMouseClickLine (label) { // Add interactivity
      // Use D3 to select element, change color and size
      var tthis = this
      var selected = new Set()
      var notSelected = new Set()
      var selectedLines = new Set()

      if (this.selectedMode === 'intersection') {
        if (this.clickedLines.has(label)) {
          this.clickedLines.delete(label)
        } else {
          this.clickedLines.add(label)
        }

        this.map.output.nodes.forEach(node => {
          var retVal = true

          this.clickedLines.forEach(label => {
            if (!tthis.lineSet[label].has(node.Id)) {
              retVal = false
            }
          })

          if (!retVal) {
            notSelected.add(node.Id)
          } else {
            selected.add(node.Id)
          }
        })

        this.map.output.paths.forEach(path => {
          if (this.clickedLines.has(path.Label)) {
            selectedLines.add(path.Label)
          }
        })
      } else if (this.selectedMode === 'union') {
        if (this.clickedLines.has(label)) {
          this.clickedLines.delete(label)
        } else {
          this.clickedLines.add(label)
        }

        this.map.output.nodes.forEach(node => {
          var retVal = false

          this.clickedLines.forEach(label => {
            if (tthis.lineSet[label].has(node.Id)) {
              retVal = true
            }
          })

          if (!retVal) {
            notSelected.add(node.Id)
          } else {
            selected.add(node.Id)
          }
        })

        this.map.output.paths.forEach(path => {
          if (this.clickedLines.has(path.Label)) {
            selectedLines.add(path.Label)
          }
        })
      } else if (this.selectedMode === 'complement') {
        if (this.clickedLines.has(label)) {
          this.clickedLines.delete(label)
        } else {
          this.clickedLines.add(label)
        }

        this.map.output.nodes.forEach(node => {
          var retVal = false

          this.clickedLines.forEach(label => {
            if (tthis.lineSet[label].has(node.Id)) {
              retVal = true
            }
          })

          if (retVal) {
            notSelected.add(node.Id)
          } else {
            selected.add(node.Id)
          }
        })

        this.map.output.paths.forEach(path => {
          if (!this.clickedLines.has(path.Label)) {
            selectedLines.add(path.Label)
          }
        })
      } else if (this.selectedMode === 'relativeComplement') {
        if (this.clickedLines.has(label)) {
          this.clickedLines.delete(label)
        } else {
          this.clickedLines.add(label)
        }

        this.map.output.nodes.forEach(node => {
          var counter = 0

          this.clickedLines.forEach(label => {
            if (tthis.lineSet[label].has(node.Id)) {
              counter = counter + 1
            }
          })

          if (counter === 1) {
            selected.add(node.Id)
          } else {
            notSelected.add(node.Id)
          }
        })

        this.map.output.paths.forEach(path => {
          if (this.clickedLines.has(path.Label)) {
            selectedLines.add(path.Label)
          }
        })
      } else if (this.selectedMode === 'subtract') {
        if (d3.event.ctrlKey || d3.event.metaKey) {
          if (this.clickedLinesSubtract.has(label)) {
            this.clickedLinesSubtract.delete(label)
          } else {
            this.clickedLinesSubtract.add(label)
          }
          if (this.clickedLines.has(label)) {
            this.clickedLines.delete(label)
          }
        } else {
          if (this.clickedLines.has(label)) {
            this.clickedLines.delete(label)
          } else {
            this.clickedLines.add(label)
          }
          if (this.clickedLinesSubtract.has(label)) {
            this.clickedLinesSubtract.delete(label)
          }
        }

        this.map.output.nodes.forEach(node => {
          var value = false

          this.clickedLines.forEach(label => {
            if (tthis.lineSet[label].has(node.Id)) {
              value = true
            }
          })

          this.clickedLinesSubtract.forEach(label => {
            if (tthis.lineSet[label].has(node.Id)) {
              value = false
            }
          })

          if (value) {
            selected.add(node.Id)
          } else {
            notSelected.add(node.Id)
          }

          this.map.output.paths.forEach(path => {
            if (this.clickedLines.has(path.Label) || this.clickedLinesSubtract.has(path.Label)) {
              selectedLines.add(path.Label)
            }
          })
        })
      }

      if (this.clickedLines.size > 0) {
        d3.selectAll('.node')
          .filter(function (dd) {
            return selected.has(dd.Id)
          })
          .transition()
          .duration(200)
          .style('opacity', 1.0)

        d3.selectAll('.text')
          .filter(function (dd) {
            return selected.has(dd.Id)
          })
          .transition()
          .duration(200)
          .style('opacity', this.showLabels ? 1.0 : 0.0)

        d3.selectAll('.node')
          .filter(function (dd) {
            return notSelected.has(dd.Id)
          })
          .transition()
          .duration(200)
          .style('opacity', 0.1)

        d3.selectAll('.text')
          .filter(function (dd) {
            return notSelected.has(dd.Id)
          })
          .transition()
          .duration(200)
          .style('opacity', this.showLabels ? 0.1 : 0.0)

        d3.selectAll('.line')
          .filter(function (dd) {
            return !selectedLines.has(dd.Label)
          })
          .transition()
          .duration(200)
          .style('opacity', 0.1)

        d3.selectAll('.line')
          .filter(function (dd) {
            return selectedLines.has(dd.Label)
          })
          .transition()
          .duration(200)
          .style('opacity', 1.0)

        d3.selectAll('.legend')
          .filter(function (d) {
            return !selectedLines.has(d.Label)
          })
          .style('font-weight', 'normal')
          .style('fill', 'black')

        d3.selectAll('.legend')
          .filter(function (d) {
            return selectedLines.has(d.Label)
          })
          .style('font-weight', 'bold')
          .style('fill', 'black')

        d3.selectAll('.legend')
          .filter(function (d) {
            return tthis.clickedLinesSubtract.has(d.Label)
          })
          .style('fill', 'red')

        this.legendColor[label].IsHover = 'normal'
        this.clickedLines.forEach(value => {
          this.legendColor[value].IsHover = 'bold'
        })

        this.selectedNodes = selected.size
        // var temp = this.legendColor
        // this.legendColor = []
        // this.legendColor = temp
      } else {
        this.refreshSelection()
      }
    },

    handleMouseOverLineD3 (d, i) { // Add interactivity
      // Use D3 to select element, change color and size
      this.handleMouseOverLine(d.Label)
    },

    handleMouseOverLine (label) {
      if (this.selectedMode !== 'hover') {
        return
      }

      var selected = 0
      d3.selectAll('.line')
        .filter(function (dd) {
          return dd.Label !== label
        })
        .transition()
        .duration(200)
        .style('opacity', 0.1)

      var tthis = this
      d3.selectAll('.node')
        .filter(function (dd) {
          if (tthis.lineSet[label].has(dd.Id)) {
            selected = selected + 1
            return false
          } else {
            return true
          }
        })
        .transition()
        .duration(200)
        .style('opacity', 0.1)

      d3.selectAll('.text')
        .filter(function (dd) {
          return !tthis.lineSet[label].has(dd.Id)
        })
        .transition()
        .duration(200)
        .style('opacity', this.showLabels ? 0.1 : 0.0)

      d3.selectAll('.legend')
        .filter(function (d) {
          return d.Label === label
        })
        .style('font-weight', 'bold')

      this.selectedNodes = selected
      // this.legendColor[label].IsHover = 'bold'
      // var temp = this.legendColor
      // this.legendColor = []
      // this.legendColor = temp
    },

    handleMouseOutLineD3 (d, i) {
      this.handleMouseOutLine(d.Label)
    },

    handleMouseOutLine (label) {
      // Use D3 to select element, change color back to normal

      if (this.selectedMode !== 'hover') {
        return
      }

      d3.selectAll('.line')
        .filter(function (dd) {
          return dd.Label !== label
        })
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      var tthis = this
      d3.selectAll('.node')
        .filter(function (dd) {
          return !tthis.lineSet[label].has(dd.Id)
        })
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      d3.selectAll('.text')
        .filter(function (dd) {
          return !tthis.lineSet[label].has(dd.Id)
        })
        .transition()
        .duration(200)
        .style('opacity', this.showLabels ? 1.0 : 0.0)

      d3.selectAll('.legend')
        .filter(function (d) {
          return d.Label === label
        })
        .style('font-weight', 'normal')

      this.selectedNodes = this.numNodes
      // this.legendColor[label].IsHover = 'normal'
      // var temp = this.legendColor
      // this.legendColor = []
      // this.legendColor = temp
    },

    handleMouseOverText (d, i, nodes) { // Add interactivity
      // Use D3 to select element, change color and size
      var el = nodes[i]

      d3.select(el)
        .text(g => {
          return g['Text']
        })
    },

    handleMouseOutText (d, i, nodes) {
      // Use D3 to select element, change color back to normal
      var el = nodes[i]

      d3.select(el)
        .text(g => {
          if (g['Abbr']) {
            return g['Text'].substring(0, 14) + '..'
          } else {
            return g['Text']
          }
        })
    },

    animatePath (map) {
      map.paths.forEach(line => {
        var path = d3.selectAll('.line')
          .filter(function (dd) {
            return dd.Label === line.Label
          })

        var length = path.node().getTotalLength()

        path
          .attr('stroke-dasharray', length + ' ' + length)
          .attr('stroke-dashoffset', length)
          .transition()
          .duration(this.animationTime)
          .ease(d3.easeLinear)
          .attr('stroke-dashoffset', 0)

        var distance = 0
        var last = line.Points[0]
        this.nodeAnimation[last.Id] = 0

        for (var i = 1; i < line.Points.length; i++) {
          var curr = line.Points[i]
          var distX = curr.X - last.X
          var distY = curr.Y - last.Y

          var dist = Math.sqrt(distX * distX + distY * distY)
          distance += dist

          if (curr.Id) {
            var factor = distance / length

            if (this.nodeAnimation[curr.Id] > factor * this.animationTime) {
              this.nodeAnimation[curr.Id] = factor * this.animationTime
            }
          }

          last = curr
        }
      })
      var tthis = this
      d3.selectAll('.node')
        .attr('opacity', 0.0)
        .transition()
        .delay(function (d, i) {
          return tthis.nodeAnimation[d.Id]
        })
        .duration(600)
        .attr('opacity', 1.0)

      d3.selectAll('.text')
        .attr('opacity', 0.0)
        .transition()
        .delay(function (d, i) {
          return tthis.nodeAnimation[d.Id]
        })
        .duration(100)
        .attr('opacity', 1.0)

      d3.select('.svg')
        .transition()
        .duration(this.animationTime)

      setTimeout(this.addHoverFunc, this.animationTime)
    },

    addHoverFunc () {
      d3.selectAll('.line')
        .on('mouseover', this.handleMouseOverLineD3)
        .on('mouseout', this.handleMouseOutLineD3)
        .on('click', this.handleMouseClickLineD3)

      d3.selectAll('.node')
        .on('mouseover', this.handleMouseOverNode)
        .on('mouseout', this.handleMouseOutNode)

      d3.selectAll('.text')
        .on('mouseover', this.handleMouseOverText)
        .on('mouseout', this.handleMouseOutText)

      d3.selectAll('.legend')
        .on('mouseover', this.handleMouseOverLineD3)
        .on('mouseout', this.handleMouseOutLineD3)
        .on('click', this.handleMouseClickLineD3)

      d3.selectAll('.lineLegend')
        .on('mouseover', this.handleMouseOverLineD3)
        .on('mouseout', this.handleMouseOutLineD3)
        .on('click', this.handleMouseClickLineD3)
    },

    scaleStation (id) {
      var num = this.nodeLineSet[id].size
      var factor = 1.0

      if (num < 3) {
        factor = 1.0
      } else if (num < 6) {
        factor = 2.0
      } else {
        factor = num / 3
      }

      return factor
    },

    scaleStationLinear (id) {
      var num = this.nodeLineSet[id].size
      var factor = 1.0

      return factor * num
    },

    modeSwitch (type) {
      this.refreshSelection()
    },

    refreshSelection () {
      this.clickedLines = new Set()
      this.clickedLinesSubtract = new Set()
      this.selectedLine = null

      d3.selectAll('.line')
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      d3.selectAll('.node')
        .transition()
        .duration(200)
        .style('opacity', 1.0)

      d3.selectAll('.text')
        .transition()
        .duration(200)
        .style('opacity', this.showLabels ? 1.0 : 0.0)

      d3.selectAll('.legend')
        .style('fill', 'black')
        .style('font-weight', 'normal')

      this.selectedNodes = this.map.output.nodes.length

      // this.map.output.paths.forEach((path) => {
      // d3.select('#label' + path.Label).style('background-color', 'green')
      //  this.legendColor[path.Label].IsHover = 'normal'
      // })
      // var temp = this.legendColor
      // this.legendColor = []
      // this.legendColor = temp
    },

    /*
      Following code is for exporting images as svg and png
    */
    exportAsSvg () {
      // var svg = d3.select('#drawArea')

      saveSvgAsPng.svgAsDataUri(document.getElementById('drawArea'), 'test.png', {
        backgroundColor: 'white',
        excludeCss: true,
        fonts: [
          {
            url: 'https://fonts.gstatic.com/s/ptsansnarrow/v11/BngRUXNadjH0qYEzV7ab-oWlsbCGwR0.woff2',
            format: 'application/font-woff2',
            text: "@font-face {font-family: 'PT Sans Narrow'; font-style: normal; font-weight: 400; src: local('PT Sans Narrow'), local('PTSans-Narrow'), url(https://fonts.gstatic.com/s/ptsansnarrow/v11/BngRUXNadjH0qYEzV7ab-oWlsbCGwR0.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }"
          },
          {
            url: 'https://fonts.gstatic.com/s/robotomono/v12/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_ROW4.woff2',
            format: 'application/font-woff2',
            text: "@font-face {font-family: 'Roboto Mono'; font-style: normal; font-weight: 400; src: local('Roboto Mono'), local('Roboto-Mono'), url(https://fonts.gstatic.com/s/robotomono/v12/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_ROW4.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }"
          }
        ]
      }).then(uri => saveAs(uri, this.map.data_name + '_metro.svg'))

      /* var width = this.$refs.drawAreaRef.clientWidth
      var height = this.$refs.drawAreaRef.clientHeight
      svg.style('width', null)
      svg.style('height', null)
      svg.attr('width', width + 'px')
      svg.attr('height', height + 'px')
      var svgString = this.getSVGString(svg.node())
      var blob = new Blob([svgString], { type: 'text/plain;charset=utf-8' })
      saveAs(blob, this.map.data_name + '_metro.svg')
      svg.attr('width', null)
      svg.attr('height', null)
      svg.style('width', '100%')
      svg.style('height', '100%') */
    },

    exportAsPng () {
      saveSvgAsPng.saveSvgAsPng(document.getElementById('drawArea'), this.map.data_name + '_metro.png', {
        backgroundColor: 'white',
        excludeUnusedCss: true,
        scale: 6,
        fonts: [
          {
            url: 'https://fonts.gstatic.com/s/ptsansnarrow/v11/BngRUXNadjH0qYEzV7ab-oWlsbCGwR0.woff2',
            format: 'application/font-woff2',
            text: "@font-face {font-family: 'PT Sans Narrow'; font-style: normal; font-weight: 400; src: local('PT Sans Narrow'), local('PTSans-Narrow'), url(https://fonts.gstatic.com/s/ptsansnarrow/v11/BngRUXNadjH0qYEzV7ab-oWlsbCGwR0.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }"
          },
          {
            url: 'https://fonts.gstatic.com/s/robotomono/v12/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_ROW4.woff2',
            format: 'application/font-woff2',
            text: "@font-face {font-family: 'Roboto Mono'; font-style: normal; font-weight: 400; src: local('Roboto Mono'), local('Roboto-Mono'), url(https://fonts.gstatic.com/s/robotomono/v12/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_ROW4.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }"
          }
        ]
      })

      /* var svg = d3.select('#drawArea')

      var width = this.$refs.drawAreaRef.clientWidth
      var height = this.$refs.drawAreaRef.clientHeight

      // set style for firefox rendering bug (9 years)
      svg.style('width', null)
      svg.style('height', null)
      svg.attr('width', width + 'px')
      svg.attr('height', height + 'px')

      var svgString = this.getSVGString(svg.node())
      this.svgString2Image(svgString, width, height, 'png', 4, this.savePng)

      // return styles to normal
      svg.attr('width', null)
      svg.attr('height', null)
      svg.style('width', '100%')
      svg.style('height', '100%') */
    },

    savePng (dataBlob, filesize) {
      saveAs(dataBlob, this.map.data_name + '_metro.png')
    },

    getSVGString (svgNode) {
      svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink')
      var cssStyleText = this.getCSSStyles(svgNode)
      this.appendCSS(cssStyleText, svgNode)

      var serializer = new XMLSerializer()
      var svgString = serializer.serializeToString(svgNode)
      svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink=') // Fix root xlink without namespace
      svgString = svgString.replace(/NS\d+:href/g, 'xlink:href') // Safari NS namespace fix
      return svgString
    },

    getCSSStyles (parentElement) {
      var selectorTextArr = []

      // Add Parent element Id and Classes to the list
      selectorTextArr.push('#' + parentElement.id)
      for (var c = 0; c < parentElement.classList.length; c++) {
        if (!this.contains('.' + parentElement.classList[c], selectorTextArr)) {
          selectorTextArr.push('.' + parentElement.classList[c])
        }
      }

      // Add Children element Ids and Classes to the list
      var nodes = parentElement.getElementsByTagName('*')
      for (var i = 0; i < nodes.length; i++) {
        var id = nodes[i].id
        if (!this.contains('#' + id, selectorTextArr)) {
          selectorTextArr.push('#' + id)
        }

        var classes = nodes[i].classList
        for (c = 0; c < classes.length; c++) {
          if (!this.contains('.' + classes[c], selectorTextArr)) {
            selectorTextArr.push('.' + classes[c])
          }
        }
      }

      // Extract CSS Rules
      var extractedCSSText = ''
      for (i = 0; i < document.styleSheets.length; i++) {
        var s = document.styleSheets[i]

        try {
          if (!s.cssRules) continue
        } catch (e) {
          if (e.name !== 'SecurityError') throw e // for Firefox
          continue
        }

        var cssRules = s.cssRules
        for (var r = 0; r < cssRules.length; r++) {
          if (this.contains(cssRules[r].selectorText, selectorTextArr)) {
            extractedCSSText += cssRules[r].cssText
          }
        }
      }

      return extractedCSSText
    },

    contains (str, arr) {
      return arr.indexOf(str) === -1 // ? false : true
    },

    switchEncoding () {
      if (this.vertexEncoding === this.vertexEncodingItems[0]) {
        d3.selectAll('.node')
          .transition()
          .duration(200)
          .attr('r', g => this.lineStroke / 2 * this.scaleStationLinear(g['Id']))
      } else {
        d3.selectAll('.node')
          .transition()
          .duration(200)
          .attr('r', g => this.lineStroke / 2 * g['PortDegree'])
      }
    },

    appendCSS (cssText, element) {
      var styleElement = document.createElement('style')
      styleElement.setAttribute('type', 'text/css')
      styleElement.innerHTML = cssText
      var refNode = element.hasChildNodes() ? element.children[0] : null
      element.insertBefore(styleElement, refNode)
    },

    svgString2Image (svgString, width, height, format, scaleRatio, callback) {
      var canvas = document.createElement('canvas')

      canvas.width = scaleRatio * width
      canvas.height = scaleRatio * height
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'
      canvas.style.display = 'block'
      canvas.getContext('2d').setTransform(scaleRatio, 0, 0, scaleRatio, 0, 0)
      var context = canvas.getContext('2d')

      var url = 'data:image/svg+xml;base64, ' + btoa(unescape(encodeURIComponent(svgString)))

      var image = new Image()
      image.onload = function () {
        context.fillStyle = '#FFFFFF'
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.drawImage(this, 0, 0)
        // context.scale(5, 5)

        canvas.toBlob(function (blob) {
          var filesize = Math.round(blob.length / 1024) + ' KB'
          if (callback) callback(blob, filesize)
        })
      }

      image.src = url
    },

    populateTooltips () {
      this.tooltip['Girth'] = 'The number of nodes of the shortest simple cycle.'
      this.tooltip['Size'] = 'Size of the layout [xmin, ymin, xmax, ymax]'
      this.tooltip['# Edges'] = 'The total number of edges in the network.'
      this.tooltip['# Nodes'] = 'The total number of nodes in the network.'
      this.tooltip['# Hyperedges'] = 'The total number of hyperedges in the input dataset.'
      this.tooltip['Monotonicity'] = 'The number of times a line reverses direction.'
      this.tooltip['Gabriel Score'] = 'The number of nodes which lie close to an edge that they aren’t connected to.'
      this.tooltip['Maximum Degree'] = 'The maximum number of edges connected to a single node.'
      this.tooltip['# Edge Crossings'] = 'The number of times two lines cross each other outside of a station.'
      this.tooltip['# Line Crossings'] = 'The number of times the ordering of lines changes between two nodes.'
      this.tooltip['# Self Crossings'] = 'The number of times a single line intersects itself.'
      this.tooltip['Consecutive Ones'] = 'The number of times a pair of lines runs together, splits apart, then rejoins later.'
      this.tooltip['Time to Create'] = 'The number of seconds spent creating the map.'
      this.tooltip['Avg Error in Edge Length'] = 'The proportion by which the average edge differs from the desired, uniform length.'
      this.tooltip['Max Error in Edge Length'] = 'The proportion by which the edge with the most extreme length differs from the desired, uniform length.'
      this.tooltip['Size of Condensed Hypergraph'] = 'The number of nodes left after discarding nodes which belong to a single hyperedge, and merging together nodes which belong to the same hyperedges.'
      this.tooltip['Avg Error in Octilinearity'] = 'The angle by which the average edge differs from a multiple of 45 degrees'
      this.tooltip['Max Error in Octilinearity'] = 'The angle by which the worst behaved edge differs from a multiple of 45 degrees'
    }
  }
}
</script>

<style scoped>
.legend {
  width: 500px;
  height: auto;
  padding: 10px;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);;
  bottom: 0;
  right: 200px;
}
.legend > div:before{
  content:"";
  float:left;
  background: black;
  width:100%;
  height:2px;
  border-radius: 3px;
}
.key-dot {
    display: inline-block;
    height: 5px;
    margin-bottom: 3px;
    margin-right: .5em;
    width: 30px;
}
.tooltip {
    padding: 10px 10px 0px 10px;
    opacity: 0.0;
    position: absolute;
    min-width: 200px;
    height: auto;
    background: white;
    border: 1px;
    border-style:solid;
    border-color: rgb(29, 128, 29);
    border-radius: 8px;
    pointer-events: none;
}
</style>
